import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { SecurityService } from 'src/app/shared/services/security.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { LiquidacionRecorridoTabsFormaPagoComponent } from './tabs-forma-pago/tabs-forma-pago.component';
import { LiquidacionControlEfectivoComponent } from '../control-efectivo/modal-liquidacion-control-efectivo.component';
import gql from 'graphql-tag';
import * as _ from 'lodash';
import Swal from 'sweetalert2';
import { ModalSeleccionarRecorridoLiquidacionComponent } from './modal-seleccionar-recorrido-liquidacion/modal-seleccionar-recorrido-liquidacion.component';
import { ModalInfoComponent } from 'src/app/shared/components/modal-info/modal-info.component';
import { SearchRecorridoTableComponent } from './search-recorrido-table/search-recorrido-table/search-recorrido-table.component';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
export class LiquidacionRecorridoComponent {
    constructor(accesolocalstorage, clog, fb, formValidatorsService, datesService, recorridoDetalleService, messageRendererService, rutService, tipoDTEService, bancoService, cuentaBancariaService, toastrService, saldoDocumentoService, client, _liquidacionRecorridoService, fileDownloadService, documentoService, condicionPagoService) {
        this.accesolocalstorage = accesolocalstorage;
        this.clog = clog;
        this.fb = fb;
        this.formValidatorsService = formValidatorsService;
        this.datesService = datesService;
        this.recorridoDetalleService = recorridoDetalleService;
        this.messageRendererService = messageRendererService;
        this.rutService = rutService;
        this.tipoDTEService = tipoDTEService;
        this.bancoService = bancoService;
        this.cuentaBancariaService = cuentaBancariaService;
        this.toastrService = toastrService;
        this.saldoDocumentoService = saldoDocumentoService;
        this._liquidacionRecorridoService = _liquidacionRecorridoService;
        this.fileDownloadService = fileDownloadService;
        this.documentoService = documentoService;
        this.condicionPagoService = condicionPagoService;
        // Data & tmp
        this.client = null;
        this.loading = false;
        this.listaRecorridosAll = null;
        this.listaRecorridos = null;
        this.paginationContext = new PaginationContext();
        this.busquedaIniciada = false;
        this.recorridoSeleccionado = null;
        this.listaTiposDte = null;
        this.currentRecorrido = null;
        this.optionsBancosEmpresa = [];
        this.optionsBancosTodos = [];
        this.optionsCuentasBancosTransferencia = [];
        this.optionsCuentasBancosDeposito = [];
        this.montosPago = [0, 0, 0]; // pos 0: monto a declarar, pos 1: abonos, pos 2: falta por declarar
        this.pagosId = -1;
        this.exito = false;
        this.saldoDocumentos = [];
        this.monto_conforme = 0;
        this.lista_clientes = [];
        this.diferencial_pago = [0, 0, 0, 0, 0, 0, 0, 0]; // total, cheque, transferencia, efectivo, transportistaTotal, TEfectivo, TCheque, TTransferencia
        this.sonMismoCliente = false;
        this.montoDoc = 0;
        this.abonos = 0;
        this.saldos = 0;
        this.btnPagar = false;
        this.operationCompleted = false;
        this.condicion_pago = '';
        this.mostrarTipoPago = [true, false, false, false];
        this.listaPagos = [];
        this.nombreBanco = '';
        this.detallePagos = null;
        this.dataSelect = [];
        this.HiddeTable = false;
        this.processing = false;
        this.detalleAbono = [];
        this.saldoDocumentoCliente = [];
        this.client = client;
        this.log = this.clog.log('LIQ-RECORRIDO');
    }
    get hayDocumentosConExcedente() {
        if (!this.listaRecorridosAll || !this.listaRecorridosAll.length)
            return false;
        return this.listaRecorridosAll.some((r) => r.tieneExcedente);
    }
    get hayDocumentosConSobrepago() {
        if (!this.listaRecorridosAll || !this.listaRecorridosAll.length)
            return false;
        return this.listaRecorridosAll.some((r) => r.cabecera && (r.cabecera.montoAbonado || 0) > (r.cabecera.monto_documento || 0));
    }
    ngOnInit() {
        this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
        this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());
        this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
        this.paginationContext.RecordsByPage = 10;
        this.detallePagos = null;
        this.loadTiposDte();
        this.createForm();
        this.formChangesSubscriptions();
        this.getBancosEmpresas();
        this.getBancosTodos();
    }
    receiveMessage($event) {
        this.message = $event;
        console.log('-> this.message', this.message);
    }
    loadTiposDte() {
        this.tipoDTEService.GetTiposDocumento(({ mensajes, respuesta }) => {
            const ok = respuesta !== null;
            if (!ok) {
                this.messageRendererService.showErrors(mensajes);
                return;
            }
            const { registros } = respuesta;
            this.listaTiposDte = registros;
        });
    }
    createForm() {
        // const fecha = this.datesService.CurrentDateToShortTimeString()
        // this.formHeader = this.fb.group({
        //   nroRecorrido: [null, [Validators.required]],
        //   // fechaDesde: [fecha, [Validators.required]],
        // });
        this.formEfectivo = this.fb.group({
            montoEfectivo: [null, [Validators.required]],
            abonarTotalSaldoPendiente: [false, [Validators.required]],
        });
        this.formCheque = this.fb.group({
            nroDocumento: [null, [Validators.required]],
            montoCheque: [null, [Validators.required]],
            abonarTotalSaldoPendiente: [false, [Validators.required]],
            fecha: [null, [Validators.required]],
            banco: [null, [Validators.required]],
            nroCuenta: [null, [Validators.required]],
        });
        this.formCobroVendedor = this.fb.group({
            pagadoVendedor: [false, [Validators.required]],
            montoCobro: [null],
        });
        this.formTransferencia = this.fb.group({
            banco: [null, [Validators.required]],
            montoTransferencia: [null, [Validators.required]],
            abonarTotalSaldoPendiente: [false, [Validators.required]],
            fecha: [null, [Validators.required]],
            nroComprobante: [null, []],
            cuentaDestino: [null, [Validators.required]],
        });
    }
    formChangesSubscriptions() {
        this.detallePagos = null;
        // this.formHeader.get("nroRecorrido").valueChanges
        // .pipe(
        //   filter(Boolean), debounceTime(750),
        //   distinctUntilChanged(),
        // )
        // .subscribe((nroRecorrido: string) => {
        //   // this.clearResults('formChangesSubscriptions')
        //   this.modalSeleccionarRecorrido.searchByCodigo(Number(nroRecorrido))
        // })
        this.formTransferencia.get('banco').valueChanges.subscribe((banco_codigo) => {
            if (banco_codigo !== null && banco_codigo !== undefined)
                this.getCuentasTransferencia(banco_codigo);
        });
    }
    clearResults(origen) {
        // this.log(`clearResults from`, origen)
        this.listaRecorridosAll = null;
        this.listaRecorridos = null;
        this.loading = false;
        this.enableOperations();
    }
    enableOperations() {
        this.operationCompleted = false;
    }
    disableOperations() {
        this.operationCompleted = true;
    }
    getBancosEmpresas() {
        this.bancoService.obtenerBancoEmpresas(this.rutEmpresa, true, ({ mensajes, respuesta }) => {
            const { registros } = respuesta;
            this.optionsBancosEmpresa = registros.map((banco) => (Object.assign({ value: banco.codigo, label: banco.nombre }, banco)));
        });
    }
    getBancoEspecifico(codigoBanco) {
        this.nombreBanco = null;
        this.nombreBanco = this.optionsBancosTodos.find((banco) => banco.codigo === codigoBanco).nombre;
    }
    getBancosTodos() {
        this.bancoService.obtenerSegunFiltro('', true, ({ mensajes, respuesta }) => {
            const { registros } = respuesta;
            this.optionsBancosTodos = registros.map((banco) => (Object.assign({ value: banco.codigo, label: banco.nombre }, banco)));
        });
    }
    getCuentasTransferencia(banco_codigo) {
        this.cuentaBancariaService.obtenerCuentaEmpresa(this.rutEmpresa, banco_codigo, true, ({ mensajes, respuesta }) => {
            const { registros } = respuesta;
            this.formTransferencia.get('cuentaDestino').setValue(null);
            this.optionsCuentasBancosTransferencia = registros.map((cuenta) => (Object.assign({ value: cuenta.numero_cuenta, label: cuenta.numero_cuenta }, cuenta)));
            this.formTransferencia.get('cuentaDestino').setValue(this.optionsCuentasBancosTransferencia[0].value);
        });
    }
    showModalSeleccionarRecorrido() {
        this.searchRecorridoTable.show();
    }
    onRecorridoSeleccionado(recorrido) {
        this.listaRecorridos = [];
        this.detallePagos = null;
        this.log('Seleccionó', recorrido);
        this.clearResults('onRecorridoSeleccionado');
        this.recorridoSeleccionado = recorrido;
        console.log('muestrame el recorrido que seleccione ', this.recorridoSeleccionado);
        // this.formHeader.get('nroRecorrido').setValue(recorrido.codigo)
        // this.modalSeleccionarRecorrido.clearLast()
    }
    onInitRecorrido(recorrido) {
        this.listaRecorridos = [];
        this.detallePagos = null;
        this.log('Seleccionó', recorrido);
        this.clearResults('onRecorridoSeleccionado');
        this.iniciarLiquidacion(1, recorrido);
    }
    onNotFoundRecorrido() {
        this.clearRecorridoData();
        this.clearResults('onNotFoundRecorrido');
    }
    clearRecorridoData() {
        this.recorridoSeleccionado = null;
    }
    limpiarfiltros() {
        this.formCheque.reset();
        this.formEfectivo.reset();
        this.formTransferencia.reset();
        this.formCobroVendedor.reset();
        this.recorridoSeleccionado = null;
        this.listaRecorridos = null;
        this.onNotFoundRecorrido();
        this.HiddeTable = false;
    }
    iniciarLiquidacion(pageNumber = 1, Rec) {
        //RECIBIR OBJETO DE RECORRIDO SELECCIONADO
        console.log('MUESTRAME EL RECORRIDO PARA INICIAR LIQUIDACION ', Rec);
        //OCULTAR TABLA DE RECORRIDO MAS FILTRO
        this.HiddeTable = true;
        this.listaRecorridos = [];
        this.detallePagos = null;
        this.busquedaIniciada = true;
        // this.formValidatorsService.validateAllFormFields(this.formHeader)
        if (!this.recorridoSeleccionado)
            return;
        this.paginationContext.CurrentPage = pageNumber;
        this.listaRecorridosAll = [];
        this.loading = true;
        this.disableOperations();
        const inputParams = {
            rutEmpresa: this.rutEmpresa,
            sucursalCodigo: this.sucursalCodigo,
            codigoRecorrido: this.recorridoSeleccionado.codigo,
            paginaActual: 1,
            cantidadRegistrosPorPagina: -1,
        };
        this.recorridoDetalleService.obtenerDetalleRecorridoConAbono(inputParams, ({ mensajes, respuesta }) => {
            if (mensajes && mensajes.length > 0) {
                this.messageRendererService.showInfoMessages(mensajes);
                this.messageRendererService.showErrors(mensajes);
                this.loading = false;
                return;
            }
            if (!respuesta || !respuesta.registros || respuesta.registros.length === 0 || respuesta.registros === null) {
                this.loading = false;
                // this.toastrService.error('Recorrido cerrado.')
                return;
            }
            // const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
            // this.paginationContext.RecordsCount = totalRegistros
            // this.paginationContext.CurrentPage = paginaActual
            // this.paginationContext.PagesCount = totalPaginas
            const { registros } = respuesta;
            this.listaRecorridosAll = registros;
            this.saldoDocumentoCliente = registros.map((x) => x.cabecera);
            let tempList = [];
            this.listaRecorridosAll.forEach((v) => {
                tempList.push(v.cabecera);
            });
            this.montoDoc = tempList.reduce((total, obj) => {
                return total + obj.monto_documento;
            }, 0);
            this.abonos = tempList.reduce((total, obj) => {
                return total + obj.montoAbonado;
            }, 0);
            this.saldos = this.montoDoc - this.abonos;
            this.paginationContext.RecordsCount = this.listaRecorridosAll.length; //totalRegistros
            this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage); //totalPaginas
            this.paginationContext.CurrentPage = pageNumber;
            this.listaRecorridosAll = registros;
            this.ajustarPagoCuenta(); // Si no es el último recorrido o no es el último abono del último recorrido, establecer pago_cuenta a 0
            this.listaRecorridosAll.map((recorrido) => {
                recorrido.cabecera.rutEmisorFormato = this.rutService.AgregarDV(recorrido.cabecera.rut_emisor);
                recorrido.cabecera.clienteProveedorRutFormato = this.rutService.AgregarDV(recorrido.cabecera.cliente_proveedor_rut);
                recorrido.cabecera.tipoDteNombre = this.getNombreTipoDte(recorrido.cabecera.tipo_dte_codigo);
                this.detallePagos = recorrido.detallePagos;
                if (this.detallePagos !== null)
                    this.detallePagos.monto_faltante = Math.abs(recorrido.detallePagos.monto_faltante);
                recorrido.tieneExcedente = recorrido.detalleAbonos && recorrido.detalleAbonos.some((abono) => (abono.pago_cuenta || 0) > 0);
            });
            this.listaRecorridosAll.map((recorrido, index) => {
                recorrido.additionalInfo = {};
                recorrido.additionalInfo.index = index;
                recorrido.additionalInfo.checked = false;
            });
            this.saldoDocumentos = [];
            console.log('listaRecorridosAll', this.listaRecorridosAll);
            if (this.listaRecorridosAll && this.listaRecorridosAll.length > 0) {
                // Verificar si la liquidación está cerrada
                // La liquidación está cerrada si: abierto === false O si algún recorrido tiene detallePagos
                const tieneDetallePagos = this.listaRecorridosAll.some(recorrido => recorrido.detallePagos !== null);
                const liquidacionCerrada = this.listaRecorridosAll[0].abierto === false || tieneDetallePagos;
                if (liquidacionCerrada) {
                    this.disableOperations();
                    this.toastrService.warning('Recorrido cerrado');
                }
                else {
                    this.enableOperations();
                }
            }
            this.listaRecorridosAll.forEach((recorrido) => {
                this.saldoDocumentoService.obtenerSaldoDocumentoCliente(Number(this.rutEmpresa), Number(1), recorrido.cabecera.cliente_proveedor_rut, false, ({ mensajes, respuesta }) => {
                    const { registros } = respuesta;
                    const ok = respuesta !== null;
                    if (!ok) {
                        this.messageRendererService.showErrors(mensajes);
                        return;
                    }
                    // if (mensajes && mensajes.length > 0) {
                    //   this.messageRendererService.showInfoMessages(mensajes)
                    //   this.messageRendererService.showErrors(mensajes)
                    //   // this.loading = false
                    //   // return
                    // }
                    console.log('Obtener Saldo documento cliente', registros);
                    registros.forEach((registro) => {
                        if (registro.folio === recorrido.cabecera.folio && registro.tipo_dte_codigo === recorrido.cabecera.tipo_dte_codigo) {
                            delete registro.__typename;
                            registro.abono = recorrido.cabecera.montoAbonado;
                            this.monto_conforme += registro.deuda;
                            this.saldoDocumentos.push(registro);
                        }
                    });
                });
            });
            this.loading = false;
            this.showPage(this.paginationContext.CurrentPage);
        });
        let data = {
            recorridoCodigo: this.recorridoSeleccionado.codigo,
        };
        this.log('data', JSON.stringify(data));
        this.recorridoDetalleService.obtenerDiferencialPago(data, ({ mensajes, respuesta }) => {
            const ok = respuesta !== null;
            if (!ok) {
                this.messageRendererService.showErrors(mensajes);
                return;
            }
            this.diferencial_pago[0] = respuesta.montoDiferencialTotal;
            this.diferencial_pago[1] = respuesta.montoDiferencialCheque;
            this.diferencial_pago[2] = respuesta.montoDiferencialTransferencia;
            this.diferencial_pago[3] = respuesta.montoDiferencialEfectivo;
            this.diferencial_pago[4] = respuesta.montoDiferencialTotalTransportista;
            this.diferencial_pago[5] = respuesta.montoDiferencialEfectivoTransportista;
            this.diferencial_pago[6] = respuesta.montoDiferencialChequeTransportista;
            this.diferencial_pago[7] = respuesta.montoDiferencialTransferenciaTransportista;
        });
    }
    ajustarPagoCuenta() {
        if (this.listaRecorridosAll && this.listaRecorridosAll.length > 0) {
            // Procesar cada documento/folio
            this.listaRecorridosAll.forEach(documento => {
                if (documento.detalleAbonos && documento.detalleAbonos.length > 0) {
                    // Encontrar el primer abono que cumpla con los criterios
                    const primerAbonoValido = documento.detalleAbonos
                        .find(abono => abono.permite_borrar === true && abono.tiene_pago_cuenta_por_dentro === true && abono.pago_cuenta > 0);
                    // Procesar cada abono
                    documento.detalleAbonos.forEach(abono => {
                        if (abono.permite_borrar === false) {
                            // Si es un abono no borrable, mantener su pago_cuenta original
                            // No hacer nada, mantener el valor original
                        }
                        else if (abono === primerAbonoValido) {
                            // Si es el primer abono válido, mantener su pago_cuenta original
                            // No hacer nada, mantener el valor original
                        }
                        else {
                            // Para los demás abonos, establecer pago_cuenta en 0
                            abono.pago_cuenta = 0;
                        }
                    });
                }
            });
        }
    }
    showPage(pageNumber) {
        this.paginationContext.CurrentPage = pageNumber;
        const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage;
        this.listaRecorridos = _.slice(this.listaRecorridosAll, start, start + this.paginationContext.RecordsByPage);
    }
    onPageChange(context) {
        this.showPage(context.RequestedPage);
    }
    obtenerClientes() {
        this.saldoDocumentos.forEach((documento) => {
            let esta = false;
            this.lista_clientes.forEach((cliente) => {
                if (documento.cliente_proveedor_rut === cliente)
                    esta = true;
            });
            if (!esta)
                this.lista_clientes.push({ cliente_proveedor_rut: documento.cliente_proveedor_rut, pagos: [], saldoDocumentos: [], monto_coforme: 0 });
        });
    }
    checkAllChange({ checked }) {
        this.listaRecorridosAll.forEach((recorrido) => {
            recorrido.additionalInfo.checked = checked;
        });
    }
    checkDetalle({ index }) {
        const selected = this.listaRecorridosAll.filter((p) => p.additionalInfo.index === index)[0];
        selected.additionalInfo.checked = !selected.additionalInfo.checked;
    }
    getNombreTipoDte(tipo_dte_codigo) {
        const _listaTiposDte = this.listaTiposDte.filter((tipoDte) => tipoDte.codigo === tipo_dte_codigo);
        if (_listaTiposDte && _listaTiposDte.length > 0)
            return _listaTiposDte[0].descripcion;
        return '';
    }
    downloadExcelPdf(type, recorrido_codigo) {
        const inputParams = {
            codigoRecorrido: recorrido_codigo,
        };
        this.recorridoDetalleService.reportePDFDetallePago(inputParams, ({ mensajes, respuesta }) => {
            console.log('🚀 ~ file: liquidacion-recorrido.component.ts ~ line 442 ~ LiquidacionRecorridoComponent ~ this.recorridoDetalleService.reportePDFDetallePago ~ respuesta', respuesta);
            const ok = respuesta !== null;
            if (!ok) {
                this.messageRendererService.showErrors(mensajes);
                return;
            }
            if (respuesta)
                this.fileDownloadService.VerifyAndDownload(respuesta.rutaDocumento);
        });
    }
    showVerAbonos(recorrido) {
        this.currentRecorrido = recorrido;
        this.verAbonosModal.show();
    }
    showModalPago() {
        let hayData = false;
        let rutSeleccionados = [];
        if (this.listaRecorridosAll) {
            console.log(this.listaRecorridosAll);
            this.dataSelect = this.listaRecorridosAll
                .map((reco) => {
                const params = {
                    checked: reco.additionalInfo.checked,
                    tipo_dte_codigo: reco.cabecera.tipo_dte_codigo,
                    folio: reco.cabecera.folio,
                    cliente_proveedor_rut: reco.cabecera.cliente_proveedor_rut,
                    direccion_codigo: reco.cabecera.direccion_codigo,
                    fechaEmisionDoc: new Date(reco.cabecera.fechaEmisionDocto),
                };
                return params;
            })
                .filter((x) => x.checked === true);
            console.log(this.dataSelect);
            this.main = _.minBy(this.dataSelect, 'fechaEmisionDoc');
            this.listaRecorridosAll.forEach((recorrido) => {
                if (recorrido.additionalInfo.checked) {
                    hayData = true;
                    rutSeleccionados.push(recorrido.cabecera.cliente_proveedor_rut);
                    this.obtenerCondicionPago(recorrido.cabecera);
                    this.montosPago[0] += recorrido.cabecera.monto_documento;
                    recorrido.detalleAbonos.forEach((abono) => {
                        this.montosPago[1] += abono.monto_pagado;
                    });
                    this.montosPago[2] = this.montosPago[0] - this.montosPago[1];
                }
            });
            console.log('Intentando agregar pago de tipo:', this.listaRecorridosAll);
            if (hayData) {
                let sonMismoCliente = true;
                let rutAnterior = 0;
                rutSeleccionados.forEach((cliente) => {
                    if (rutAnterior === 0)
                        rutAnterior = cliente;
                    else if (rutAnterior != cliente) {
                        sonMismoCliente = false;
                        return;
                    }
                });
                if (sonMismoCliente) {
                    this.sonMismoCliente = true;
                    this.dataCliente = this.dataSelect[0];
                    for (let i = 1; i < this.dataSelect.length; i++) {
                        if (this.dataSelect[i].fechaEmisionDoc < this.dataCliente.fechaEmisionDoc) {
                            this.dataCliente = this.dataSelect[i];
                        }
                    }
                    this.verPagoModal.show();
                }
                else {
                    //this.toastrService.warning('Los documentos seleccionados a pagar deben pertenecer al mismo cliente.')
                    this.verPagoModal.show();
                }
            }
            else
                this.toastrService.warning('Debe seleccionar documentos');
        }
    }
    obtenerCondicionPago(cliente) {
        const inputParams = {
            entidad: {
                codigo: cliente.condicion_pago_codigo,
            },
        };
        this.condicionPagoService.obtenerSegunId(inputParams, ({ respuesta }) => {
            const self = this;
            if (respuesta != null) {
                const { descripcion } = respuesta;
                this.condicion_pago = descripcion;
            }
        });
    }
    onAceptarFormaPago(value) {
        this.log('onAceptarFormaPago', value);
    }
    eliminarAbono(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.exito = false;
            this.client.mutate({
                mutation: gql `
          mutation ($entidad: liquidacion_recorridoInputType) {
            liquidacion_recorrido {
              eliminarAbonos(entidad: $entidad) {
                respuesta {
                  listaPagos {
                    monto_pago
                  }
                }
              }
            }
          }
        `,
                fetchPolicy: 'no-cache',
                variables: {
                    entidad: data,
                },
            }, (respuesta) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                yield this.actualizarInfoAbonos(true, 'Abonos eliminados correctamente.');
            }));
        });
    }
    cerrarLiquidacion() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.listaRecorridosAll) {
                if (this.lista_clientes.length === 0)
                    this.obtenerClientes();
                if (this.verificarPagos()) {
                    let formasDePago = [];
                    let pagos = [];
                    let montoDocumentos = 0;
                    let montoAbonado = 0;
                    //console.log('Lista de Clientes: ', this.lista_clientes)
                    //this.lista_clientes.forEach((cliente) => {
                    this.processing = true;
                    let montoPagado = 0; // Abonos de fuera (permite_borrar === false)
                    let montoRecorrido = 0; // Total de todos los abonos
                    let montoCobroVendedorDesdeDentro = 0; // Cobro vendedor solo de abonos de dentro
                    let montoOtrosPagosDesdeDentro = 0; // Otros pagos (efectivo, transferencia, cheque) solo de abonos de dentro
                    let tieneCobroVendedorDesdeDentro = false;
                    let tieneOtrosPagosDesdeDentro = false;
                    this.listaRecorridosAll.forEach((recorrido) => {
                        let pagoCliente = { saldoDocumento: [], forma_pago: [], difereciaPago: [], monto_coforme: 0 };
                        {
                            montoDocumentos += recorrido.cabecera.monto_documento;
                            let montoAbonoDTE = 0;
                            recorrido.detalleAbonos.forEach((abono) => {
                                console.log('Abono: ', abono);
                                this.detalleAbono.push(abono);
                                let montoAbono = 0;
                                // Separar abonos de dentro (permite_borrar === true) de los de fuera (permite_borrar === false)
                                if (abono.permite_borrar) {
                                    // Abono desde dentro de la liquidación
                                    montoAbono = abono.monto_pagado;
                                    montoAbonoDTE += abono.monto_pagado;
                                    // Verificar tipo de pago para abonos de dentro
                                    if (abono.tipo_pago === 'Cobro vendedor') {
                                        montoCobroVendedorDesdeDentro += abono.monto_pagado;
                                        tieneCobroVendedorDesdeDentro = true;
                                    }
                                    else {
                                        // Efectivo, Transferencia, Cheque, Depósito
                                        montoOtrosPagosDesdeDentro += abono.monto_pagado;
                                        tieneOtrosPagosDesdeDentro = true;
                                    }
                                }
                                else {
                                    // Abono desde fuera de la liquidación
                                    montoPagado += abono.monto_pagado;
                                }
                                montoRecorrido += abono.monto_pagado;
                                delete abono.__typename;
                                montoAbonado += abono.monto_pagado;
                                let tipo_pago = abono.tipo_pago_codigo;
                                let numero_documento = '0';
                                let numero_cuenta = '0';
                                if (abono.tipo_pago === 'Transferencia') {
                                    tipo_pago = 2;
                                    if (!abono.nro_comprobante_transferencia && abono.nro_comprobante_transferencia.trim() != '') {
                                        numero_documento = abono.nro_comprobante_transferencia;
                                    }
                                    if (!abono.numero_cuenta) {
                                        numero_cuenta = abono.numero_cuenta;
                                    }
                                }
                                else if (abono.tipo_pago === 'Efectivo')
                                    tipo_pago = 3;
                                else if (abono.tipo_pago === 'Deposito' || abono.tipo_pago === 'Depósito') {
                                    tipo_pago = 4;
                                    numero_cuenta = abono.numero_cuenta;
                                    numero_documento = abono.numero_documento;
                                }
                                else if (abono.tipo_pago === 'Cheque') {
                                    numero_documento = abono.numero_documento;
                                    numero_cuenta = abono.numero_cuenta;
                                }
                                else {
                                    console.log('*********', abono.tipo_pago);
                                    tipo_pago = 5;
                                    if (abono.tipo_pago === 'Cobro vendedor') {
                                        // Este monto ya se contabilizó arriba si es de dentro
                                    }
                                    //numerodoc = '-1'
                                }
                                if (numero_documento && numero_documento.trim() === '') {
                                    numero_documento = '0';
                                }
                                console.log('numero_documento: ', numero_documento);
                                const formaPago = {
                                    tipo_pago_codigo: tipo_pago,
                                    empresa_rut: abono.rut_emisor,
                                    tipo_cuenta_bancaria_codigo: abono.tipo_cuenta_bancaria_codigo,
                                    banco_codigo: abono.banco_codigo,
                                    banco_nombre: abono.banco_nombre,
                                    numero_cuenta: numero_cuenta,
                                    fecha_pago: abono.fecha_documento,
                                    monto: montoAbono,
                                    sucursal_codigo: this.sucursalCodigo,
                                    numero_doc: numero_documento,
                                    tipo_pago_nombre: abono.tipo_pago,
                                    excedente: abono.pago_cuenta,
                                };
                                if (abono.permite_borrar) {
                                    pagoCliente.forma_pago.push(formaPago);
                                }
                                formasDePago.push(formaPago);
                                //cliente.pagos.push(formaPago)
                            });
                            pagoCliente.saldoDocumento.push(this.getDocument(recorrido, montoAbonoDTE));
                        }
                        pagos.push(pagoCliente);
                    });
                    // Detectar documentos con cobro vendedor + pago externo donde el total abonado supera el monto del documento (sobrepagados)
                    const docsSobrepagados = this.listaRecorridosAll.filter(r => {
                        const tieneCV = r.detalleAbonos.some(a => a.tipo_pago === 'Cobro vendedor' && a.permite_borrar === true);
                        const tienePagoExterno = r.detalleAbonos.some(a => a.permite_borrar === false);
                        if (!tieneCV || !tienePagoExterno)
                            return false;
                        const montoDoc = (r.cabecera && r.cabecera.monto_documento) || 0;
                        const montoTotal = r.detalleAbonos.reduce((sum, a) => sum + (a.monto_pagado || 0), 0);
                        return montoTotal > montoDoc + 0.01;
                    });
                    if (docsSobrepagados.length > 0) {
                        const folios = docsSobrepagados.map(d => d.cabecera.folio).join(', ');
                        const clientes = [...new Set(docsSobrepagados.map(d => d.cabecera.nombreCliente))].join(', ');
                        const result = yield Swal.fire({
                            title: 'Documentos con cobro vendedor y pago externo',
                            html: `Los documentos <b>${folios}</b> del cliente <b>${clientes}</b> tienen cobro vendedor y además un pago realizado por fuera.<br><br>¿Desea continuar con el cierre de la liquidación?`,
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Sí, continuar',
                            cancelButtonText: 'No, volver',
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                        });
                        if (!result.isConfirmed) {
                            this.processing = false;
                            return;
                        }
                    }
                    console.log(this.detalleAbono);
                    const montoAbono = _.sumBy(this.detalleAbono, 'monto_pagado');
                    // Verificar si el abono está completo: saldo = 0, sobrepago (saldoTotal < 0) o diferencia de centavos
                    const saldoTotal = montoDocumentos - montoAbonado;
                    const abonoCompleto = saldoTotal <= 0.01;
                    // Lógica de cierre:
                    // 1. Si está completamente abonado Y no hay otros pagos desde dentro Y no hay sobrepagos → cerrar automáticamente
                    // 2. Si hay documentos sobrepagados (cobro vendedor + pago externo) → siempre pasar por control de efectivo
                    // 3. Si tiene otros pagos desde dentro (efectivo, cheque, transferencia) → mostrar modal de control de efectivo
                    // 4. Si no está completamente abonado → mostrar modal de control de efectivo
                    const debeCerrarAutomaticamente = abonoCompleto && !tieneOtrosPagosDesdeDentro && docsSobrepagados.length === 0;
                    if (debeCerrarAutomaticamente) {
                        this.saldoDocumentoCliente.map((x) => {
                            delete x.ruta_codigo;
                            delete x.nombreCliente;
                            delete x.fechaEmisionDocto;
                            delete x.fechaVencimientoDocto;
                            delete x.montoAbonado;
                            delete x.estado;
                            delete x.estadoDocumento;
                            delete x.sucursal_codigo;
                            delete x.documento;
                            delete x.condicion_pago_codigo;
                            delete x.rutEmisorFormato;
                            delete x.clienteProveedorRutFormato;
                            delete x.tipoDteNombre;
                            delete x.__typename;
                        });
                        const inputParams = {
                            rutEmpresa: this.rutEmpresa,
                            sucursalCodigo: this.sucursalCodigo,
                            codigoRecorrido: this.recorridoSeleccionado.codigo,
                            monto: montoAbono,
                            saldoDocumentoCliente: this.saldoDocumentoCliente,
                            rutUsuario: this.rutUsuario,
                        };
                        this._liquidacionRecorridoService.cerrarLiquidacion(inputParams, ({ mensajes, respuesta }) => {
                            if (mensajes && mensajes.length > 0) {
                                this.messageRendererService.showInfoMessages(mensajes);
                                this.messageRendererService.showErrors(mensajes);
                                if (mensajes.filter((m) => m.tipo === 'ERROR').length > 0) {
                                    this.processing = false;
                                    return;
                                }
                            }
                            this.modalInfo.showWithInlineConfig('Recorrido cerrado', 'Nada que declarar, recorrido cerrado con éxito', () => {
                                this.iniciarLiquidacion(1);
                                this.processing = false;
                            });
                        });
                    }
                    else {
                        const modalControlEfectivoMainData = {
                            pagos,
                            forma_pago: formasDePago,
                            diferencial_pago: this.diferencial_pago[0],
                            diferenciales: this.diferencial_pago,
                            declaracionControl: {
                                vendedor_codigo: 0,
                                empresa_rut: this.rutEmpresa,
                                sucursal_codigo: this.sucursalCodigo,
                                chofer_rut: 0,
                                cliente_proveedor_rut: 0,
                                otro: '',
                            },
                        };
                        this.modalControlEfectivoComponent.loadData(modalControlEfectivoMainData, this.recorridoSeleccionado, montoPagado, montoRecorrido, montoCobroVendedorDesdeDentro);
                        this.processing = false;
                    }
                }
                else
                    this.toastrService.warning('Deben estar todos los documentos pagados para cerrar la liquidación.');
            }
            else
                this.toastrService.warning('Debe iniciar una liquidación.');
        });
    }
    getDocument(recorrido, montoAbonoDTE) {
        let value = false;
        const newSaldoDocumento = {
            rut_emisor: recorrido.cabecera.rut_emisor,
            sucursal_codigo: recorrido.cabecera.sucursal_codigo,
            fecha_emision: recorrido.cabecera.fechaEmisionDocto,
            fechaVencimientoDocto: recorrido.cabecera.fechaVencimientoDocto,
            tipo_pago: recorrido.cabecera.documento,
            folio: recorrido.cabecera.folio,
            tipo_dte_codigo: recorrido.cabecera.tipo_dte_codigo,
            cliente_proveedor_rut: recorrido.cabecera.cliente_proveedor_rut,
            monto: 0,
            abono: montoAbonoDTE,
        };
        return newSaldoDocumento;
        /*
        this.listaRecorridosAll.forEach((documento) => {
          if (documento.rutEmpresa === recorrido.cabecera.rut_emisor &&
            documento.folio === recorrido.cabecera.folio &&
            documento.cliente_proveedor_rut === recorrido.cabecera.cliente_proveedor_rut
          )
            value = documento;
        });
        return value;*/
    }
    verificarPagos() {
        let cantDocPagados = 0;
        this.listaRecorridosAll.forEach((recorrido) => {
            if (recorrido.cabecera.estado === 1)
                cantDocPagados++;
        });
        if (cantDocPagados === this.listaRecorridosAll.length)
            return true;
        else
            return false;
    }
    onTipoPagoSelect(tipoPago) {
        this.clearFormEfectivo();
        this.clearFormCobroVendedor();
        this.clearFormCheque();
        this.clearFormTransferencia();
        if (this.mostrarTipoPago[tipoPago])
            this.mostrarTipoPago[tipoPago] = false;
        else {
            this.mostrarTipoPago = this.mostrarTipoPago.map(() => {
                return false;
            });
            this.mostrarTipoPago[tipoPago] = true;
        }
        this.obtenerFechaVencimiento();
        this.formTransferencia.get('fecha').setValue(this.fecha_liquidacion);
    }
    onRecibeFecha(fechaLiquidacion) {
        this.fecha_liquidacion = fechaLiquidacion;
    }
    obtenerFechaVencimiento() {
        if (this.mostrarTipoPago[1] === true) {
            const inputParams = {
                // rutEmpresa: this.rutEmpresa,
                // folioDocumento: this.min.folio,
                // tipoDocumento: this.min.tipo_dte_codigo,
                rut_empresa: this.rutEmpresa,
                sucursal_codigo: this.sucursalCodigo,
                cliente_proveedor_rut: this.dataCliente.cliente_proveedor_rut,
                direccion_codigo: this.dataCliente.direccion_codigo,
                condicion_pago_codigo: 0,
                fecha_documento: this.dataCliente.fechaEmisionDoc,
            };
            //funcion para obtener Fecha Vencimiento 2
            this.documentoService.ObtenerFechaVencimiento(inputParams, ({ mensajes, respuesta }) => {
                const ok = respuesta !== null;
                if (!ok) {
                    this.messageRendererService.showErrors(mensajes);
                    return;
                }
                this.formCheque.get('fecha').setValue(respuesta.fecha_vencimiento);
            });
        }
    }
    abonarTotalSaldoPendiente({ checked }, tipoPago) {
        if (tipoPago === 0)
            //efectivo
            checked ? this.formEfectivo.controls['montoEfectivo'].setValue(this.montosPago[2]) : this.formEfectivo.controls['montoEfectivo'].setValue(0);
        else if (tipoPago === 1)
            //cheque
            checked ? this.formCheque.controls['montoCheque'].setValue(this.montosPago[2]) : this.formCheque.controls['montoCheque'].setValue(0);
        else if (tipoPago === 2)
            //cobro vendedor
            checked ? this.formCobroVendedor.controls['pagadoVendedor'].setValue(true) : this.formCobroVendedor.controls['pagadoVendedor'].setValue(false);
        //transferencia
        else
            checked ? this.formTransferencia.controls['montoTransferencia'].setValue(this.montosPago[2]) : this.formTransferencia.controls['montoTransferencia'].setValue(0);
    }
    agregarPago(tipoPago) {
        let monto = null;
        console.log(this.montosPago[2]);
        if (this.formCheque.get('banco').value != null) {
            this.getBancoEspecifico(Number(this.formCheque.get('banco').value));
        }
        this.obtenerFechaVencimiento();
        if (tipoPago === 0) {
            //  efectivo
            monto = Number(this.formEfectivo.get('montoEfectivo').value);
            this.formValidatorsService.validateAllFormFields(this.formEfectivo);
            if (!this.formEfectivo.valid)
                return;
            if (monto) {
                if (monto > this.montosPago[2]) {
                    this.modalConfirm.showWithInlineConfig('Confirmar solicitud', 'Valor pagado, excede valor del documento. ¿Desea agregar el abono?', () => {
                        this.listaPagos.push({
                            idPago: (this.pagosId += 1),
                            tipoPago: 'Efectivo',
                            tipo_pago_codigo: 3,
                            banco_codigo: null,
                            banco_nombre: null,
                            empresa_rut: 0,
                            numero_cuenta: null,
                            monto_pago: monto,
                            numero_documento: null,
                            fecha_documento: null,
                            nro_comprobante_transferencia: null,
                            abonarTotalSaldoPendiente: this.formEfectivo.get('abonarTotalSaldoPendiente').value,
                            nroChequeComprobante: null,
                        });
                        this.clearFormEfectivo();
                        if (monto) {
                            this.montosPago[1] += monto;
                            this.montosPago[2] = this.montosPago[0] - this.montosPago[1];
                        }
                    });
                }
                else {
                    this.listaPagos.push({
                        idPago: (this.pagosId += 1),
                        tipoPago: 'Efectivo',
                        tipo_pago_codigo: 3,
                        banco_codigo: null,
                        banco_nombre: null,
                        empresa_rut: 0,
                        numero_cuenta: null,
                        monto_pago: monto,
                        numero_documento: null,
                        fecha_documento: null,
                        nro_comprobante_transferencia: null,
                        abonarTotalSaldoPendiente: this.formEfectivo.get('abonarTotalSaldoPendiente').value,
                        nroChequeComprobante: null,
                    });
                    this.clearFormEfectivo();
                    if (monto) {
                        this.montosPago[1] += monto;
                        this.montosPago[2] = this.montosPago[0] - this.montosPago[1];
                    }
                }
            }
        }
        else if (tipoPago === 1) {
            // cheque
            monto = Number(this.formCheque.get('montoCheque').value);
            this.formValidatorsService.validateAllFormFields(this.formCheque);
            if (!this.formCheque.valid)
                return;
            if (monto) {
                if (monto > this.montosPago[2]) {
                    this.modalConfirm.showWithInlineConfig('Confirmar solicitud', 'Valor pagado, excede valor del documento. ¿Desea agregar el abono?', () => {
                        this.listaPagos.push({
                            idPago: (this.pagosId += 1),
                            tipoPago: 'Cheque',
                            tipo_pago_codigo: 1,
                            banco_codigo: this.formCheque.get('banco').value,
                            banco_nombre: this.nombreBanco,
                            empresa_rut: 0,
                            numero_cuenta: this.formCheque.get('nroCuenta').value,
                            monto_pago: monto,
                            numero_documento: this.formCheque.get('nroDocumento').value,
                            fecha_documento: this.formCheque.get('fecha').value,
                            nro_comprobante_transferencia: null,
                            abonarTotalSaldoPendiente: this.formCheque.get('abonarTotalSaldoPendiente').value,
                            nroChequeComprobante: this.formCheque.get('nroDocumento').value,
                        });
                        this.clearFormCheque();
                        if (monto) {
                            this.montosPago[1] += monto;
                            this.montosPago[2] = this.montosPago[0] - this.montosPago[1];
                        }
                    });
                }
                else {
                    this.listaPagos.push({
                        idPago: (this.pagosId += 1),
                        tipoPago: 'Cheque',
                        tipo_pago_codigo: 1,
                        banco_codigo: this.formCheque.get('banco').value,
                        banco_nombre: this.nombreBanco,
                        empresa_rut: 0,
                        numero_cuenta: this.formCheque.get('nroCuenta').value,
                        monto_pago: monto,
                        numero_documento: this.formCheque.get('nroDocumento').value,
                        fecha_documento: this.formCheque.get('fecha').value,
                        nro_comprobante_transferencia: null,
                        abonarTotalSaldoPendiente: this.formCheque.get('abonarTotalSaldoPendiente').value,
                        nroChequeComprobante: this.formCheque.get('nroDocumento').value,
                    });
                    this.clearFormCheque();
                    if (monto) {
                        this.montosPago[1] += monto;
                        this.montosPago[2] = this.montosPago[0] - this.montosPago[1];
                    }
                }
            }
        }
        else if (tipoPago === 2) {
            // cobro vendedor
            monto = this.montosPago[2];
            if (monto) {
                this.listaPagos.push({
                    idPago: (this.pagosId += 1),
                    tipoPago: 'Cobro vendedor',
                    tipo_pago_codigo: 5,
                    banco_codigo: null,
                    banco_nombre: null,
                    empresa_rut: 0,
                    numero_cuenta: null,
                    monto_pago: monto,
                    numero_documento: null,
                    fecha_documento: null,
                    nro_comprobante_transferencia: null,
                    abonarTotalSaldoPendiente: true,
                    nroChequeComprobante: null,
                });
                this.clearFormCobroVendedor();
                if (monto) {
                    this.montosPago[1] += monto;
                    this.montosPago[2] = this.montosPago[0] - this.montosPago[1];
                }
            }
        }
        else {
            // transferencia
            monto = Number(this.formTransferencia.get('montoTransferencia').value);
            this.formValidatorsService.validateAllFormFields(this.formTransferencia);
            if (!this.formTransferencia.valid)
                return;
            if (monto) {
                if (monto > this.montosPago[2]) {
                    this.modalConfirm.showWithInlineConfig('Confirmar solicitud', 'Valor pagado, excede valor del documento. ¿Desea agregar el abono?', () => {
                        this.listaPagos.push({
                            idPago: (this.pagosId += 1),
                            tipoPago: 'Transferencia',
                            tipo_pago_codigo: 2,
                            banco_codigo: this.formTransferencia.get('banco').value,
                            banco_nombre: this.nombreBanco,
                            empresa_rut: 0,
                            numero_cuenta: this.formTransferencia.get('cuentaDestino').value,
                            monto_pago: monto,
                            numero_documento: null,
                            fecha_documento: this.formTransferencia.get('fecha').value,
                            nro_comprobante_transferencia: this.formTransferencia.get('nroComprobante').value,
                            abonarTotalSaldoPendiente: this.formTransferencia.get('abonarTotalSaldoPendiente').value,
                            nroChequeComprobante: this.formTransferencia.get('nroComprobante').value,
                        });
                        this.clearFormTransferencia();
                        if (monto) {
                            this.montosPago[1] += monto;
                            this.montosPago[2] = this.montosPago[0] - this.montosPago[1];
                        }
                    });
                }
                else {
                    this.listaPagos.push({
                        idPago: (this.pagosId += 1),
                        tipoPago: 'Transferencia',
                        tipo_pago_codigo: 2,
                        banco_codigo: this.formTransferencia.get('banco').value,
                        banco_nombre: this.nombreBanco,
                        empresa_rut: 0,
                        numero_cuenta: this.formTransferencia.get('cuentaDestino').value,
                        monto_pago: monto,
                        numero_documento: null,
                        fecha_documento: this.formTransferencia.get('fecha').value,
                        nro_comprobante_transferencia: this.formTransferencia.get('nroComprobante').value,
                        abonarTotalSaldoPendiente: this.formTransferencia.get('abonarTotalSaldoPendiente').value,
                        nroChequeComprobante: this.formTransferencia.get('nroComprobante').value,
                    });
                    this.clearFormTransferencia();
                    if (monto) {
                        this.montosPago[1] += monto;
                        this.montosPago[2] = this.montosPago[0] - this.montosPago[1];
                    }
                }
                const fecha = this.datesService.CurrentDateToShortTimeString();
                this.formTransferencia.get('fecha').setValue(fecha);
            }
        }
        // if (monto) {
        //   this.montosPago[1] += monto
        //   this.montosPago[2] = this.montosPago[0] - this.montosPago[1]
        // }
    }
    borrarPago(id) {
        let idABorrar = -1;
        this.listaPagos.forEach((tipoPago, index) => {
            if (tipoPago.idPago === id)
                idABorrar = index;
        });
        if (idABorrar > -1) {
            this.montosPago[1] -= this.listaPagos[idABorrar].monto_pago;
            this.montosPago[2] += this.listaPagos[idABorrar].monto_pago;
            this.listaPagos.splice(idABorrar, 1);
        }
    }
    clearFormEfectivo() {
        this.formEfectivo.reset({ abonarTotalSaldoPendiente: false });
    }
    clearFormCobroVendedor() {
        this.formCobroVendedor.reset({ pagadoVendedor: false });
    }
    clearFormCheque() {
        this.formCheque.reset({ abonarTotalSaldoPendiente: false });
    }
    clearFormTransferencia() {
        this.formTransferencia.reset({ abonarTotalSaldoPendiente: false });
    }
    crearPago() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.btnPagar = true;
            const pagina = this.paginationContext.CurrentPage;
            if (this.listaPagos.length) {
                this.listaRecorridosAll.map((recorrido) => {
                    if (recorrido.additionalInfo.checked) {
                        this.listaPagos.map((pago) => {
                            pago.empresa_rut = recorrido.cabecera.rut_emisor;
                        });
                        recorrido.liquidacionRecorridoPago = this.listaPagos;
                    }
                });
            }
            yield this.crearLiquidacionRecorridoPago(pagina);
            // this.closeModalPagos()
        });
    }
    mostrarModalEliminacion() {
        let hayData = false;
        if (this.listaRecorridosAll) {
            this.listaRecorridosAll.forEach((recorrido) => {
                if (recorrido.additionalInfo.checked && recorrido.cabecera.montoAbonado > 0)
                    hayData = true;
            });
            if (hayData)
                this.eliminarAbonos.show();
            else
                this.toastrService.warning('Los documentos seleccionados deben estar abonados.');
        }
        else {
            this.toastrService.warning('Debe seleccionar documentos.');
        }
    }
    eliminarPagos() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let data = { recorrido: this.recorridoSeleccionado, documentos: [], listaPagos: [] };
            this.listaRecorridosAll.forEach((recorrido) => {
                if (recorrido.additionalInfo.checked)
                    data.documentos.push({
                        rut_emisor: recorrido.cabecera.rut_emisor,
                        cliente_proveedor_rut: recorrido.cabecera.cliente_proveedor_rut,
                        folio: recorrido.cabecera.folio,
                        tipo_dte_codigo: recorrido.cabecera.tipo_dte_codigo,
                        monto_documento: recorrido.cabecera.monto_documento,
                    });
            });
            delete data.recorrido.__typename;
            delete data.recorrido.rutChoferFormato;
            if (data.documentos) {
                yield this.eliminarAbono(data);
                this.eliminarAbonos.hide();
            }
        });
    }
    crearLiquidacionRecorridoPago(pagina = 1) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //Variable para desactivar boton Pagar al presionarlo;
            this.montosPago[2] = 1;
            this.exito = false;
            let data = { recorrido: this.recorridoSeleccionado, documentos: [], listaPagos: [] };
            this.listaRecorridosAll.forEach((recorrido) => {
                let abonos = 0;
                recorrido.detalleAbonos.forEach((abono) => {
                    abonos += abono.monto_pagado;
                });
                if (recorrido.additionalInfo.checked)
                    data.documentos.push({
                        rut_emisor: recorrido.cabecera.rut_emisor,
                        sucursal_codigo: recorrido.cabecera.sucursal_codigo,
                        cliente_proveedor_rut: recorrido.cabecera.cliente_proveedor_rut,
                        folio: recorrido.cabecera.folio,
                        tipo_dte_codigo: recorrido.cabecera.tipo_dte_codigo,
                        monto_documento: recorrido.cabecera.monto_documento - abonos,
                    });
            });
            this.log(JSON.stringify({
                entidad: data,
            }));
            this.listaPagos.forEach((pago) => {
                data.listaPagos.push({
                    tipo_pago_codigo: pago.tipo_pago_codigo,
                    banco_codigo: pago.banco_codigo,
                    empresa_rut: 0,
                    numero_cuenta: pago.numero_cuenta,
                    monto_pago: pago.monto_pago,
                    numero_documento: pago.numero_documento,
                    fecha_documento: pago.fecha_documento,
                    nro_comprobante_transferencia: pago.nro_comprobante_transferencia,
                });
            });
            delete data.recorrido.__typename;
            delete data.recorrido.rutChoferFormato;
            this.log(JSON.stringify({ entidad: data }));
            this.client.mutate({
                mutation: gql `
          mutation ($entidad: liquidacion_recorridoInputType) {
            liquidacion_recorrido {
              agregarLiquidacionRecorridoPago(entidad: $entidad) {
                respuesta {
                  listaPagos {
                    monto_pago
                  }
                }
              }
            }
          }
        `,
                fetchPolicy: 'no-cache',
                variables: {
                    entidad: data,
                },
            }, (respuesta) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                this.btnPagar = false;
                if (respuesta.data.liquidacion_recorrido.agregarLiquidacionRecorridoPago.respuesta.listaPagos) {
                    yield this.actualizarInfoAbonos(true, 'Abonos agregados correctamente.', pagina);
                    this.closeModalPagos();
                }
                else
                    yield this.actualizarInfoAbonos(false, '');
            }));
        });
    }
    actualizarInfoAbonos(valor, msg, pagina = 1) {
        this.exito = valor;
        this.exito ? this.toastrService.success(msg) : this.toastrService.error('Ha ocurrido un error.');
        this.iniciarLiquidacion(pagina);
    }
    closeModalPagos() {
        this.mostrarTipoPago[0] = true;
        this.mostrarTipoPago[1] = false;
        this.mostrarTipoPago[2] = false;
        this.mostrarTipoPago[3] = false;
        this.sonMismoCliente = false;
        this.listaPagos = [];
        this.montosPago = [0, 0, 0];
        this.condicion_pago = '';
        this.clearFormEfectivo();
        this.clearFormCobroVendedor();
        this.clearFormCheque();
        this.clearFormTransferencia();
        this.verPagoModal.hide();
    }
    controlEfectivoRealizado() {
        this.iniciarLiquidacion();
        this.disableOperations();
    }
    esSobrepagado(recorrido) {
        if (!recorrido.detalleAbonos || recorrido.detalleAbonos.length === 0)
            return false;
        const tieneCV = recorrido.detalleAbonos.some((a) => a.tipo_pago === 'Cobro vendedor' && a.permite_borrar === true);
        const tienePagoExterno = recorrido.detalleAbonos.some((a) => a.permite_borrar === false);
        if (!tieneCV || !tienePagoExterno)
            return false;
        const montoDoc = (recorrido.cabecera && recorrido.cabecera.monto_documento) || 0;
        const montoTotal = recorrido.detalleAbonos.reduce((sum, a) => sum + (a.monto_pagado || 0), 0);
        return montoTotal > montoDoc + 0.01;
    }
}
